import { render, staticRenderFns } from "./matchTournamentDetail.vue?vue&type=template&id=f83c4c88&scoped=true&"
import script from "./matchTournamentDetail.vue?vue&type=script&lang=js&"
export * from "./matchTournamentDetail.vue?vue&type=script&lang=js&"
import style0 from "./matchTournamentDetail.vue?vue&type=style&index=0&id=f83c4c88&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f83c4c88",
  null
  
)

export default component.exports